import Image from 'next/image';
import PropTypes from 'prop-types';
import React from 'react';

import { shimmer } from 'utility/shimmer';

const ImageKit = (props) => {
	const { src, alt, width, height, ...others } = props;

	return (
		<Image
			blurDataURL={`data:image/svg+xml;base64,${shimmer(width, height, 12)}`}
			src={src || ''}
			alt={alt}
			width={width}
			height={height}
			{...(!others.priority && {
				loading: 'lazy',
			})}
			{...others}
		/>
	);
};

export default ImageKit;

ImageKit.defaultProps = {
	quality: 50,
	layout: 'intrinsic',
	priority: false,
	src: '',
	alt: 'keepa',
};

ImageKit.propTypes = {
	layout: PropTypes.oneOf(['fill', 'intrinsic', 'responsive', 'fixed']),
	priority: PropTypes.bool.isRequired,
	alt: PropTypes.string.isRequired,
	src: PropTypes.string,
	placeholder: PropTypes.string,
	loader: PropTypes.string,
	blurDataURL: PropTypes.string,
	className: PropTypes.string,
	objectFit: PropTypes.string,
};
